import { BiLocalizedText } from '@euler/model/bi/catalog';

/** A server label in the app's language; euler ships Chinese copy only. */
export function biText(text: BiLocalizedText): string {
  return text.zh || text.en;
}
